module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "accountmanager"
  }, _vm._l((_vm.targetData), function(item, ele, index) {
    return _c('div', {
      key: index,
      staticClass: "accountmanager_item"
    }, [_c('p', {
      staticClass: "accountmanager_item_title"
    }, [_vm._v(_vm._s(ele))]), _vm._v(" "), _c('p', {
      staticClass: "accountmanager_item_desc"
    }, [_vm._v(_vm._s(item))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17ea4dd2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/AccountManager.vue
// module id = 1157
// module chunks = 0